import { FEATURE_KEYS } from "../constants/platform";

export const WORKSPACE_TYPES = {
  INTERNAL: "internal",
  CUSTOMER: "customer",
  PARTNER: "partner",
};

export const NAVIGATION_ITEMS = {
  internal: [
    {
      label: "Dashboard",
      icon: "🏠",
      href: "/admin/dashboard",
    },

    // =========================
    // SALES & CRM
    // =========================
    {
      label: "CRM",
      icon: "💼",
      href: "/admin/leads",
      requiredRoles: [
        "sales",
        "customer_success",
        "consultant",
        "admin",
        "super_admin",
      ],
    },
    {
      label: "Leads Dashboard",
      icon: "👥",
      href: "/admin/leads-dashboard",
      requiredRoles: [
        "sales",
        "customer_success",
        "consultant",
        "admin",
        "super_admin",
      ],
    },
    {
      label: "Follow-Ups",
      icon: "📞",
      href: "/admin/follow-ups",
      requiredRoles: [
        "sales",
        "customer_success",
        "consultant",
        "admin",
        "super_admin",
      ],
    },

    // =========================
    // ESG & DOCUMENTS
    // =========================
    {
      label: "Document Intelligence",
      icon: "📄",
      href: "/admin/advisory-documents",
      requiredRoles: [
        "consultant",
        "admin",
        "super_admin",
      ],
    },
    {
      label: "Evidence Library",
      icon: "📚",
      href: "/admin/evidence-library",
      requiredRoles: [
        "consultant",
        "admin",
        "super_admin",
      ],
    },
    {
      label: "Customer Dashboard",
      icon: "🏢",
      href: "/admin/customers",
      requiredRoles: [
        "customer_success",
        "consultant",
        "admin",
        "super_admin",
      ],
    },
    {
      label: "AI Copilot",
      icon: "✨",
      href: "/app/copilot",
      requiredRoles: [
        "consultant",
        "admin",
        "super_admin",
      ],
    },

    // =========================
    // PLATFORM
    // =========================
    {
      label: "Analytics",
      icon: "📊",
      href: "/admin/analytics",
      requiredRoles: [
        "admin",
        "super_admin",
      ],
    },
    {
      label: "Administration",
      icon: "⚙️",
      href: "/admin/settings",
      requiredRoles: [
        "admin",
        "super_admin",
      ],
    },
  ],

  customer: [
    {
      label: "Dashboard",
      icon: "🏠",
      href: "/app/dashboard",
    },
    {
      label: "Reports",
      icon: "📑",
      href: "/app/reports",
      requiredFeature: FEATURE_KEYS.REPORTING,
    },
    {
      label: "Materiality",
      icon: "🎯",
      href: "/app/materiality",
      requiredFeature: FEATURE_KEYS.MATERIALITY,
    },
    {
      label: "Document Intelligence",
      icon: "📄",
      href: "/app/documents",
      requiredFeature: FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    },
    {
      label: "Evidence Library",
      icon: "📚",
      href: "/app/evidence-library",
      requiredFeature: FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    },
    {
      label: "AI Copilot",
      icon: "✨",
      href: "/app/copilot",
      requiredFeature: FEATURE_KEYS.AI_ADVISORY_REPORTS,
    },
    {
      label: "Analytics",
      icon: "📊",
      href: "/app/analytics",
    },
    {
      label: "Billing",
      icon: "💳",
      href: "/app/billing",
    },
    {
      label: "Settings",
      icon: "⚙️",
      href: "/app/settings",
    },
  ],

  partner: [
    {
      label: "Dashboard",
      icon: "🏠",
      href: "/partner/dashboard",
    },
    {
      label: "Clients",
      icon: "🏢",
      href: "/partner/clients",
    },
    {
      label: "Document Intelligence",
      icon: "📄",
      href: "/partner/documents",
      requiredFeature: FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    },
    {
      label: "Evidence Library",
      icon: "📚",
      href: "/partner/evidence-library",
      requiredFeature: FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    },
    {
      label: "AI Advisor",
      icon: "🤖",
      href: "/partner/ai-advisor",
      requiredFeature: FEATURE_KEYS.AI_ADVISORY_REPORTS,
    },
    {
      label: "Reports",
      icon: "📑",
      href: "/partner/reports",
    },
    {
      label: "Analytics",
      icon: "📊",
      href: "/partner/analytics",
    },
    {
      label: "Settings",
      icon: "⚙️",
      href: "/partner/settings",
    },
  ],
};